const getAuthV2Url = () => {
  const env = location.hostname === 'localhost' ? 'local' : process.env.__environment__;

  const authDomains = {
    local: 'https://api.skykit-int.app/auth/v2/graphql',
    int: 'https://api.skykit-int.app/auth/v2/graphql',
    qa: 'https://api.skykit-qa.app/auth/v2/graphql',
    stage: 'https://api.skykit-stage.app/auth/v2/graphql',
    prod: 'https://api.skykit.app/auth/v2/graphql',
  };

  return authDomains[env];
};

const getAuthQueryNoTenantQuery = `
    query AuthV2NoTenant {
        identity {
            platformAdminActive
            platformAdminCapable
            user {
                id
                email
            }
        }
    }
`;

const getEditionsAddonsQueryById = `
    query AuthV2Editions {
        addons {
            id
            description
            gidV3
            lid
            name
        }
        editions {
            id
            description
            gidV3
            lid
            name
        }
        
    }
`;

// identity {
//     user {
//     permits(after: null, first: 200) {
//       pageInfo {
//         hasNextPage
//         hasPreviousPage
//         startCursor
//         endCursor
//       }
//       edges {
//         cursor
//         node {
//           lid
//           gidV3
//           tenant {
//             lid
//           }
//         }
//       }
//     }
//   }
// }

module.exports = {
  getAuthV2Url,
  getAuthQueryNoTenantQuery,
  getEditionsAddonsQueryById,
};
